import type { PaginatedResponse, PaginationParams, SortDirection, SortParams } from '@hetivo/hetivo-lib-types';

/**
 * Map frontend pagination + sort params to backend query params.
 * Used by all search API calls.
 */
export function toQueryParams<TSortColumn extends string>(
  params: PaginationParams & { sort?: SortParams<TSortColumn> },
): Record<string, number | string> {
  const query: Record<string, number | string> = {
    limit: params.pageSize,
    page: params.page,
  };
  if (params.sort) {
    query.sort = params.sort.sortBy;
    query.sortDirection = params.sort.sortDirection;
  }
  return query;
}

/**
 * Map backend HetivoPaginatedResponse to frontend PaginatedResponse.
 * Identity mapper that keeps the contract explicit.
 */
export function mapPaginatedResponse<T>(response: PaginatedResponse<T>): PaginatedResponse<T> {
  return {
    items: response.items,
    page: response.page,
    pageSize: response.pageSize,
    total: response.total,
    totalPages: response.totalPages,
  };
}

/** @deprecated Use mapPaginatedResponse instead please */
export const toPaginatedResponse = mapPaginatedResponse;

/**
 * Build sort params from a column key and direction.
 * Returns undefined when direction is null (i.e., sort was cleared).
 */
export function buildSortParams<TSortColumn extends string>(
  sortBy: TSortColumn,
  sortDirection: SortDirection | null,
): SortParams<TSortColumn> | undefined {
  return sortDirection === null ? undefined : { sortBy, sortDirection };
}
